/// <reference path="./t/knockout.d.ts" />

module App {
  "use strict";

  export enum Pages {
    None = 0,
    Main = 1
  }

  export class Orchestrator {

    public version = ko.observable("");

    private _pageIds: {
      [key: number]: string
    } = {};

    public currentUserName = ko.observable("Cornel");

    private _mainVM: MainVM;

    private _activePage: Pages;

    constructor() {

      this._activePage = Pages.None;
      
      this._pageIds[Pages.None] = "none";
      this._pageIds[Pages.Main] = "mainPage";

      this._mainVM = new MainVM(this);

      let sessionId: number = Math.floor(Math.random() * 30000);

      ko.applyBindings(this._mainVM, document.getElementById(this._pageIds[Pages.Main]));

      ko.applyBindings(this, document.getElementById('navigation'));
      
      let self: Orchestrator = this;

      this.gotoMainPage();
    }

    private static uniqueID(): string {
      function chr4() {
        return Math.random().toString(16).slice(-4);
      }

      let machineId: string = window.localStorage.getItem(`${Application.AppBackend}-machineId`);

      if (machineId) {
        return machineId;
      }

      machineId = `${chr4()}${chr4()}-${chr4()}-${chr4()}-${chr4()}-${chr4()}${chr4()}${chr4()}`;

      window.localStorage.setItem(`${Application.AppBackend}-machineId`, machineId);

      return machineId;
    }

    public showProgress(show: boolean): void {
    }

    private _toggleActivation(page: string, activate: boolean): void {
      if (activate) {
        document.getElementById(page).classList.remove("pageHost");
      } else {
        document.getElementById(page).classList.add("pageHost");
      }
    }

    // #region Pages

    public showPage(page: Pages, show: boolean) {
      this._toggleActivation(this._pageIds[page], show);
    }

    public activatePage(page: Pages): void {
      this._activePage = page;

      this._toggleActivation(this._pageIds[page], true);

      switch (page) {
        case Pages.Main:
          this._mainVM.activate();
          break;
        default:
          alert('cannot activate page ' + page);
          break;
      }
    }

    public gotoMainPage(): void {

      // we have all is needed to register for push notifications
      //this._registerForWebNotifications();

      this.activatePage(Pages.Main);
    }

    // #endregion Pages

    public dump(): string {

      let obj: any = {
        someMember: 'some value'
      };

      return JSON.stringify(obj);
    }     
  }
}